import { Box } from '@mui/material';
import { RenderTable } from '../../../../components/ui';
import TBody from './TBody';
import TFoot from './TFoot';
import THead from './THead';
interface IProps {
  apiData: any;
  year:any;
  month: any;
}
const TController = ({ apiData, year, month }: IProps) => {
  return (
    <Box>
      <RenderTable>
          <THead year={year} month={month} />
          <TBody apiData={apiData} />
          <TFoot apiData={apiData} />
      </RenderTable>
    </Box>
  );
};

export default TController;
